module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage addrule_edit"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": true,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "头像",
      "prop": "photo"
    }
  }, [_c('imgs-upload', {
    attrs: {
      "tips": "（推荐尺寸：400*400）",
      "limit": "1"
    },
    on: {
      "change": _vm.fileChange
    },
    model: {
      value: (_vm.params.photo),
      callback: function($$v) {
        _vm.$set(_vm.params, "photo", $$v)
      },
      expression: "params.photo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主页图",
      "prop": "homeChart"
    }
  }, [_c('imgs-upload', {
    attrs: {
      "tips": "（推荐尺寸：1920*600）",
      "limit": "1"
    },
    on: {
      "change": _vm.fileChange
    },
    model: {
      value: (_vm.params.homeChart),
      callback: function($$v) {
        _vm.$set(_vm.params, "homeChart", $$v)
      },
      expression: "params.homeChart"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "社交账号",
      "prop": "status"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openSj
    }
  }, [_vm._v("添加账号")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "data": _vm.params.lawyerSocialaccountsList,
      "header-cell-style": {
        background: '#F3F4F7',
        color: '#555'
      },
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "platform",
      "label": "社交平台"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "社交账号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "webUrl",
      "label": "网址",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "urlQrcode",
      "label": "账号二维码",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "操作",
      "header-align": "center",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.delRow(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增社交",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "width": "560px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closedDialog
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.fromDialog,
      "label-width": "100px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "社交平台"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "sjpt",
      "paramsKey": "major",
      "plaText": "社交平台"
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.fromDialog.platformId),
      callback: function($$v) {
        _vm.$set(_vm.fromDialog, "platformId", $$v)
      },
      expression: "fromDialog.platformId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号名称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.fromDialog.account),
      callback: function($$v) {
        _vm.$set(_vm.fromDialog, "account", $$v)
      },
      expression: "fromDialog.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "网址"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.fromDialog.webUrl),
      callback: function($$v) {
        _vm.$set(_vm.fromDialog, "webUrl", $$v)
      },
      expression: "fromDialog.webUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号二维码"
    }
  }, [_c('imgs-upload', {
    attrs: {
      "image": _vm.fromDialog.urlQrcode,
      "tips": "（115*70推荐）"
    },
    on: {
      "imgChange": _vm.imgChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addDialog
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-4e67233d"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/user/lawyer_library/add/src/subpage3.vue
// module id = 1487
// module chunks = 1